export default "__VITE_ASSET__B5XbZ96S__"